import React from "react";
import Create from "modules/atmFees/components/Create";

const AtmFeesCreatePage = () => {
  return <Create />;
};

export default AtmFeesCreatePage;
